// extracted by mini-css-extract-plugin
export default {"base":"vp_VC93u","loader":"vp_NEhdD","wrapper":"vp_oVs4M","container":"vp_LzTgM","overflow":"vp_MwJ0W","left":"vp_pY3BZ","right":"vp_G76nz","visible":"vp_qhAU0","table":"vp_OMnJz"};